import { KeysetItem } from './keyset-item';
import { FamilyGenerationPair } from '../family-generation-pair';

export class Keyset {
    id: number;
    name: string;
    items: KeysetItem[];
    familyGenerationPairs: FamilyGenerationPair[];
}